import { type ReactElement } from 'react'
import { useProfile } from '@front/model'
import { useQueryDisclosure } from '@hooks'
import { ButtonAdd, type ButtonAddProps } from 'app/components/buttons'
import { PermissionCheckWrapper } from 'app/components/permissions'
import { TDrawer } from 'app/components/terros'
import { AddUserForm, type AddUserFormProps } from './AddUserForm'

export type AddUserButtonProps = Omit<ButtonAddProps, 'onClick'> & AddUserFormProps

export const AddUserButton = ({ companyId, teamId, onAddUser, ...props }: AddUserButtonProps): ReactElement => {
  const { company } = useProfile()
  const [opened, { close, toggle }] = useQueryDisclosure('addNewUser')
  return (
    <PermissionCheckWrapper permissionType='user:add' targetId={[company?.companyId, teamId, companyId]}>
      <ButtonAdd {...props} onClick={toggle} />
      <TDrawer opened={opened} size='lg' title='Add User' onClose={close}>
        <AddUserForm companyId={companyId} teamId={teamId} onAddUser={onAddUser} />
      </TDrawer>
    </PermissionCheckWrapper>
  )
}
